exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ies-actions td[data-v-11ceabce]:first-child{\n    padding:0px;\n}\n", ""]);

// exports
